import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Planzone, Resource, Zone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  resources: Identifiable<Resource>[];
  retrieveZoneResources(
    request: Boundaries["retrieveZoneResources"]["request"],
  ): void;
}

function useZoneResourcesRetrieval(zone: Identifiable<Zone>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isZoneResourcesRetrievalRequestPending(zone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isZoneResourcesRetrievalRequestSuccess(zone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isZoneResourcesRetrievalRequestFailure(zone),
    ),
    resources: useSelector(() => selector.getZoneResources(zone)),
    retrieveZoneResources: core.retrieveZoneResources,
  };
}

export { useZoneResourcesRetrieval };
